import { left, right } from 'fp-ts/lib/Either';
import { csosUpmApi, ResponseCSOSHeaders } from '..';

export interface IRevokeRoles {
  revokeList: {
    deaInfoId: number;
    serialNumber: string;
    userProfileId: number;
  }[];
  requestorComments: string;
}

export const revokeRoles =
  (hR: ResponseCSOSHeaders) => async (input: IRevokeRoles) =>
    csosUpmApi(hR)
      .post(`v1/api/team/revoke/roles`, input)
      .then(r => right(r.data))
      .catch(e => left(e));
// export const revokeRoles =
//   (hR: ResponseCSOSHeaders) => async (input: IRevokeRoles) =>
//     Promise.resolve()
//       .then(r => right(void 0))
//       .catch(e => left(e));
